import { render, staticRenderFns } from "./logoList.vue?vue&type=template&id=2ad236bc&"
import script from "./logoList.vue?vue&type=script&lang=js&"
export * from "./logoList.vue?vue&type=script&lang=js&"
import style0 from "./logoList.vue?vue&type=style&index=0&id=2ad236bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports